import axios from 'axios';
import qs from 'qs';
import store from '../store';
import {
    Message,
    Loading
}
from 'element-ui';

const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV);

let loading = null;

export function getToken(data) {
    axios.interceptors.request.use(config => {
        loading = Loading.service({
            lock: true
        });
        return config;
    }, error => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
        if (loading) {
            loading.close();
        }
        if (response.data) {
            if (response.data.access_token) {
                store.dispatch('user/setToken', response.data.access_token);
                if (response.data.userInfo) {
                    store.dispatch('user/setUser', JSON.parse(response.data.userInfo));
					console.log('登录成功', JSON.parse(response.data.userInfo));
                }
                Message.closeAll();
                Message({
                    message: '登录成功',
                    type: 'success',
                    duration: 5 * 1000,
                    showClose: true
                });
                return Promise.resolve(response.data);
            } else {
                Message.closeAll();
                Message({
                    message: 'token获取失败',
                    type: 'error',
                    duration: 5 * 1000,
                    showClose: true
                });
                return Promise.reject(new Error('token获取失败'));
            }
        } else {
            if (response.access_token) {
                store.dispatch('user/setToken', response.access_token);
                if (response.userInfo) {
                    store.dispatch('user/setUser', JSON.parse(response.userInfo));
                }
                Message.closeAll();
                Message({
                    message: '登录成功',
                    type: 'success',
                    duration: 5 * 1000,
                    showClose: true
                });
                return Promise.resolve(response);
            } else {
                Message.closeAll();
                Message({
                    message: 'token获取失败',
                    type: 'error',
                    duration: 5 * 1000,
                    showClose: true
                });
                return Promise.reject(new Error('token获取失败'));
            }
        }
    }, error => {
        if (loading) {
            loading.close();
        }
        let msg = '用户信息错误';
        if (error.response && error.response.data && error.response.data.error_description) {
            msg = error.response.data.error_description;
        }
        Message.closeAll();
        Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000,
            showClose: true
        });
        store.dispatch('user/logout');
        return Promise.reject(error);
    });
    return axios.post(`${(IS_PROD ? (window.location.origin + '/') : process.env.VUE_APP_BASE_API)}token`, qs.stringify(data), {
        timeout: 30000,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
